import { Button } from "@4uhub/lib4uhub";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Box, CircularProgress } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { IViewMoreProps } from "./models";

const translationPath = "page.panels.";

export const ViewMore = memo(
  ({ loading, hasNextPage, viewMoreHandler }: IViewMoreProps) => {
    const { t } = useTranslation();

    return (
      <Box
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        {loading && <CircularProgress />}
        {hasNextPage && (
          <Button
            startIcon={<ExpandMoreRoundedIcon />}
            loading={loading}
            onClick={viewMoreHandler}
          >
            {t(translationPath + "view_more")}
          </Button>
        )}
      </Box>
    );
  }
);
